import { Stack } from 'expo-router';

import PlatformContainer from '@/components/web/PlatformContainer';

const NotificationsLayout = () => {
  return (
    <PlatformContainer contentCustomClassnames="flex flex-col">
      <Stack
        screenOptions={{
          headerShown: false,
          headerShadowVisible: false,
          headerBackVisible: false
        }}>
        <Stack.Screen
          name="index"
          options={{
            headerShown: true
          }}
        />
      </Stack>
    </PlatformContainer>
  );
};

export default NotificationsLayout;
